import { ImportExportWizardMode } from '../../typings/importExportWizard';

export const UPDATE_IMPORT_EXPORT_WIZARD_MODE = 'UPDATE_IMPORT_EXPORT_WIZARD_MODE';
export type UPDATE_IMPORT_EXPORT_WIZARD_MODE = typeof UPDATE_IMPORT_EXPORT_WIZARD_MODE;

export interface UpdateImportExportWizardMode {
    type: UPDATE_IMPORT_EXPORT_WIZARD_MODE;
    mode: ImportExportWizardMode;
}

export function updateImportExportWizardModeAction(mode: ImportExportWizardMode): UpdateImportExportWizardMode {
    return {
        type: UPDATE_IMPORT_EXPORT_WIZARD_MODE,
        mode
    };
}
